import { NavLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';

export const UndecoratedNavLink = styled(NavLink)`
  text-decoration: none;
  color: inherit;
`;
